import { PropsWithChildren } from 'react';

import { cn } from '@/lib/utils';

const PricingSectionBadgeOfHonor = ({ children }: PropsWithChildren) => {
  return (
    <div
      className={cn(
        'h-6',
        'bg-gradient-secondary-1',
        'text-label-medium dark:text-base-dark-white uppercase font-serif',
        'flex items-center justify-center'
      )}
    >
      {children}
    </div>
  );
};

export default PricingSectionBadgeOfHonor;
